import { defineComponent as _defineComponent } from 'vue'
import MapBoxMap from '@/@web/ui/components/map/MapBoxMap.vue'
import { onBeforeUnmount, onMounted, provide, watch } from 'vue'
import { ExclusionZoneViewModel } from '../viewmodels/ExclusionZone.viewmodel'
import { ExclusionZoneRepositoryApiAdapter } from '@/@core/exclusion-zone/infra/ExclusionZoneRepositoryApi.adapter'
import { MonitoredAreaRepositoryApiAdapter } from '@/@core/monitored-area/infra/monitored-area-repository-adapter/MonitoredAreaRepositoryApi.adapter'
import { fireRiskApi } from '@/services/clients/AxiosClients'
import { feature, featureCollection } from '@turf/turf'
import Button from '@/components/ui/button/Button.vue'
import { FeatureCollection, Geometry } from 'geojson'
import MapBoxZoomControl from '@/@web/ui/components/map/MapBoxZoomControl.vue'
import MapBoxDrawPolygonControl from '@/@web/ui/components/map/MapBoxDrawPolygonControl.vue'
import MapBoxDrawDeleteControl from '@/@web/ui/components/map/MapBoxDrawDeleteControl.vue'
import { MapFillLayerFactory } from '../../../ui/components/map/factories/MapFillLayer.factory'
import { MapOutlineLayerFactory } from '../../../ui/components/map/factories/MapOutlineLayer.factory'
import MapBoxLayer from '../../../ui/components/map/MapBoxLayer.vue'
import MapBoxSource from '../../../ui/components/map/MapBoxSource.vue'
import MapLayout from '../../@shared/layouts/Map.layout.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Zones.page',
  setup(__props) {

const repository = new ExclusionZoneRepositoryApiAdapter(fireRiskApi)
const monitoredAreaRepository = new MonitoredAreaRepositoryApiAdapter(fireRiskApi)

const vm = new ExclusionZoneViewModel(repository, monitoredAreaRepository)
provide('exclusion-zone-view-model', vm)

onMounted(() => {
	if (!vm.exclusionZone.value.description) {
		vm.goToExclusionZonePage()
	}
})

watch(
	() => vm.drawnFeatures.value,
	() => vm.fitBounds(),
	{ deep: true },
)

watch(
	() => vm.exclusionZone.value.monitoredAreaId,
	() => vm.fitBounds(),
)

watch(
	() => vm.exclusionZone.value.zones,
	(value) => {
		if (value.length) {
			const features = value.map((zone: Geometry) =>
				Object.assign(feature(zone), {
					properties: {
						cor: '#F82027',
					},
				}),
			)
			const geojson = featureCollection(features) as FeatureCollection

			vm.drawnFeatures.value = geojson
		}
	},
	{
		immediate: true,
	},
)

onBeforeUnmount(() => vm.resetState())

return { __sfc: true,repository, monitoredAreaRepository, vm, MapBoxMap, Button, MapBoxZoomControl, MapBoxDrawPolygonControl, MapBoxDrawDeleteControl, MapFillLayerFactory, MapOutlineLayerFactory, MapBoxLayer, MapBoxSource, MapLayout }
}

})